module.exports = __webpack_public_path__ + "static/img/our-customers-industry-hero-lowres.ad8694a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-industry-hero-lowres.jpg
// module id = kUgg
// module chunks = 0